import { render } from "./ModalChild.vue?vue&type=template&id=17513e0d&scoped=true"
const script = {}

import "./ModalChild.vue?vue&type=style&index=0&id=17513e0d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17513e0d"]])

export default __exports__